// Pure helper: is this string a URL we are willing to render as a clickable
// link (http/https only)? Rejects javascript:, data:, bare text, etc. (#792)
export function isSafeHttpUrl(value: string | null | undefined): boolean {
  if (typeof value !== "string") return false
  const s = value.trim()
  if (s === "") return false
  let parsed: URL
  try {
    parsed = new URL(s)
  } catch {
    return false
  }
  if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return false
  return parsed.hostname.length > 0
}

/**
 * Href to render for a stored link. Legacy values were saved without a scheme
 * ("chat.whatsapp.com/x"), so a scheme-less value is prefixed with https://
 * first. Returns null when the result still isn't http/https (javascript:,
 * data:, blank, junk) — callers then render plain text instead of an anchor.
 */
export function toSafeHttpHref(value: string | null | undefined): string | null {
  if (typeof value !== "string") return null
  const s = value.trim()
  if (s === "") return null
  const hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(s)
  const candidate = hasScheme ? s : `https://${s}`
  return isSafeHttpUrl(candidate) ? candidate : null
}
